__turbopack_context__.v({
  "container": "Container-module-scss-module___yMdya__container",
});
